import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { GlobalStore } from './schema';
import { createAppSlice } from './slices/createAppSlice';
import { createAuthSlice } from './slices/createAuthSlice';
import { createCompassSlice } from './slices/createCompassSlice';
import { createMiscSlice } from './slices/createMiscSlice';
import { createOnboardingSlice } from './slices/createOnboardingSlice';
import { createProjectSlice } from './slices/createProjectSlice';
import { createSnackbarSlice } from './slices/createSnackbarSlice';
import { createUserSlice } from './slices/createUserSlice';
export type { UserState, GlobalStore } from './schema';

export const useGlobalStore = create<GlobalStore>()(
  devtools(
    (...a) => ({
      ...createAuthSlice(...a),
      ...createAppSlice(...a),
      ...createSnackbarSlice(...a),
      ...createUserSlice(...a),
      ...createProjectSlice(...a),
      ...createMiscSlice(...a),
      ...createCompassSlice(...a),
      ...createOnboardingSlice(...a),
    }),
    {
      name: 'CalyxGlobalStore',
      serialize: {
        replacer: (_key: string, value: unknown) => {
          if (_key === 'filterState') return '[FilterState]';
          return value;
        },
      },
    }
  )
);
